import { $Color, $tag, TaggedEnumUnion, tagEnum } from '@suntex.core/types';

import { buildStaticContext } from '../utils';

const $ = 'NumberFamily';

export const NumberFamily = {
  WholeNumbers: tagEnum($, 0),
  Fractions: tagEnum($, 1),
  Decimals: tagEnum($, 2),
  Integers: tagEnum($, 3),
} as const;

export type NumberFamily = TaggedEnumUnion<typeof NumberFamily>;

export const $NumberFamily = buildStaticContext({
  [$tag]: $,
  [NumberFamily.WholeNumbers]: {
    value: NumberFamily.WholeNumbers,
    slug: 'num',
    label: 'Whole Numbers',
    color: $Color.from('#3300cc'),
  },
  [NumberFamily.Fractions]: {
    value: NumberFamily.Fractions,
    slug: 'frc',
    label: 'Fractions',
    color: $Color.from('#ff7700'),
  },
  [NumberFamily.Decimals]: {
    value: NumberFamily.Decimals,
    slug: 'dec',
    label: 'Decimals',
    color: $Color.from('#00bbaa'),
  },
  [NumberFamily.Integers]: {
    value: NumberFamily.Integers,
    slug: 'int',
    label: 'Integers',
    color: $Color.from('#cc00dd'),
  },
} as const);
